
import { IContainer } from '../interface/container';
import { bindUserSession } from '../interface/state';
import userState from './userState';


function _bindUserState(container: IContainer) {
    const manager = userState();
    bindUserSession(manager, container);
}

export function bind(container: IContainer): Promise<void> {
    return new Promise(function(resolve, reject) {
        const binders = [_bindUserState];

        for ( const binder of binders ) {
            binder.call(null, container);
        }

        resolve();
    })
}
